import { useState, useRef, useEffect } from "react";
import { Toast, Loading } from "@alpaca/framework";
import { Modal } from "antd";
import { UserInfoSelector } from "../../store/reduxSelector.jsx";

import { fetchPermissionsForUser } from "../../service/permission/permission.js";
import { sendInvitationService } from "../../service/invite/invite.js";

import "./invite.styles.scss";
import InviteWizard from "./inviteFormWizard/inviteWizard.jsx";

function InviteModal(props) {
  const user = UserInfoSelector();
  const toastRef = useRef(null);
  const [isSendingInvitation, setIsSendingInvitation] = useState(false);
  const [permissions, setPermissions] = useState([]);

  useEffect(() => {
    const fetchPermissions = async () => {
      try {
        const res = await fetchPermissionsForUser("", "");
        const data = res.data.map((el) => ({
          ...el,
          isGranted: false,
        }));
        setPermissions(data);
      } catch (error) {
        toastRef.current?.open({
          title: "Get permission Failed",
          description: error.message,
          status: "error",
        });
      }
    };
    fetchPermissions();
  }, []);

  return (
    <>
      <Toast ref={toastRef} />
      <Modal
        centered
        destroyOnClose
        open={props.open}
        onCancel={onExitModal}
        title="Invite User"
        width={1000}
        // height={800}
        footer={false}
        maskClosable={true}
        zIndex={1006}
      >
        <Loading
          spinning={isSendingInvitation}
          size="large"
          tip="Sending invitation..."
        >
          <InviteWizard
            permissions={permissions}
            onUserCreate={onCreateUser}
            onInviteUser={onSendInvite}
            onClose={onExitModal}
          />
        </Loading>
      </Modal>
    </>
  );

  /* methods */
  function onExitModal() {
    props.onCancel();
  }

  function onCreateUser(userData) {
    setIsSendingInvitation(true);
    sendInvitationService({
      email_list: [userData.email],
      company: user.company,
      profile_name: user.profile_name,
      message: "",
      invited_permission: JSON.stringify(userData.permissions),
      invited_premade_profile_name: userData.username,
      invited_premade_profile: JSON.stringify(userData),
    })
      .then(() => onFinishInvite(userData))
      .catch(onErrorInvite);
  }

  async function onSendInvite(invitationList) {
    setIsSendingInvitation(true);
    sendInvitationService({
      inviteList: invitationList,
      company: user.company,
      profile_name: user.profile_name,
      message: "",
    }).catch(onErrorInvite);
    setIsSendingInvitation(false);
  }

  function onFinishInvite(data) {
    setIsSendingInvitation(false);
    if (props.sendInvitation) {
      props.sendInvitation(data);
    }
    return toastRef.current.open({
      title: "Invite Completed",
      description: "Your invitation has been emailed successfully.",
      status: "success",
    });
  }

  function onErrorInvite(error) {
    setIsSendingInvitation(false);
    toastRef.current.open({
      title: "Invite Failed",
      description: error.message,
      duration: 5,
      status: "error",
    });
  }
}

export default InviteModal;
